import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons-img/user.svg'


const _withScopeId = n => (_pushScopeId("data-v-5e253c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Groups ")
const _hoisted_4 = { class: "app-component-header__title" }
const _hoisted_5 = {
  key: 0,
  class: "controls"
}
const _hoisted_6 = { class: "controls-invite" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Invite People")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "javascript:void(0);" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-settings2" })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "tabs" }
const _hoisted_11 = { class: "overview" }
const _hoisted_12 = { class: "description" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, " Info ", -1))
const _hoisted_14 = { class: "info-text" }
const _hoisted_15 = { class: "members" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, " Members ", -1))
const _hoisted_17 = { class: "card" }
const _hoisted_18 = {
  key: 0,
  class: "icons"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "posts" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, " Posts ", -1))
const _hoisted_22 = {
  key: 0,
  class: "owner"
}
const _hoisted_23 = {
  key: 1,
  class: "owner"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Owner Name ")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_add_group_image = _resolveComponent("add-group-image")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_spaces_user = _resolveComponent("spaces-user")!
  const _component_app_message_input = _resolveComponent("app-message-input")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_group_edit_popup = _resolveComponent("group-edit-popup")!
  const _component_spaces_manage_members_pop_up = _resolveComponent("spaces-manage-members-pop-up")!
  const _component_group_settings_popup = _resolveComponent("group-settings-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.dataRequest)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: "Loading group data ..."
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_header, { class: "header" }, {
        "top-left": _withCtx(() => [
          _createVNode(_component_router_link, {
            to: "/spaces/groups",
            class: "back-link"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        "top-middle": _withCtx(() => [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.groupInfo.name), 1)
        ]),
        "top-right": _withCtx(() => [
          (_ctx.groupInfo.ownerId === _ctx.mainStore.user.accountId && _ctx.activeName === 'members')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "javascript:void(0);",
                class: "back-link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleManage && _ctx.handleManage(...args)))
              }, " Manage "))
            : _createCommentVNode("", true),
          (_ctx.groupInfo.ownerId === _ctx.mainStore.user.accountId && _ctx.activeName === 'overview' || _ctx.activeName === 'posts')
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: "javascript:void(0);",
                class: "back-link",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleManage && _ctx.handleManage(...args)))
              }, " Edit "))
            : _createCommentVNode("", true)
        ]),
        bottom: _withCtx(() => [
          _createVNode(_component_add_group_image, {
            "group-cover": _ctx.groupCover,
            onUpdateCoverPhoto: _ctx.handleUpdateCoverPhoto
          }, null, 8, ["group-cover", "onUpdateCoverPhoto"])
        ]),
        _: 1
      }),
      (_ctx.groupInfo.ownerId === _ctx.mainStore.user.accountId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                type: "primary",
                round: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              class: "controls-settings",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.settingsEdit = true))
            }, _hoisted_9)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.activeName,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activeName) = $event)),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "Overview",
              name: "overview",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tabName = 'overview'))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.groupInfo.groupInfo), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      (_ctx.membersOverview.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membersOverview, (member) => {
                              return (_openBlock(), _createElementBlock("img", {
                                key: member.accountId,
                                class: "icon-img",
                                src: _ctx.getMemberPhoto(member.photo),
                                alt: ""
                              }, null, 8, _hoisted_19))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["all", { 'no-users': !_ctx.membersOverview.length }])
                      }, _toDisplayString(_ctx.groupInfo?.members?.length) + " " + _toDisplayString(_ctx.membersText), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    (_ctx.posts.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, " There are no posts yet. "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "Members",
              name: "members",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tabName = 'members'))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupInfo.members, (user) => {
                  return (_openBlock(), _createBlock(_component_spaces_user, {
                    onHandleUserUpdate: _ctx.fetchGroupData,
                    user: user,
                    key: user.accountId,
                    "user-type": _ctx.NETWORK_CONTACT_TYPES.GROUP_MANAGE
                  }, null, 8, ["onHandleUserUpdate", "user", "user-type"]))
                }), 128)),
                (_ctx.groupInfo?.members?.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, " There are no members yet. "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupInfo.invitedUsers, (user) => {
                  return (_openBlock(), _createBlock(_component_spaces_user, {
                    user: user,
                    key: user.accountId,
                    "user-type": user.type
                  }, null, 8, ["user", "user-type"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "Posts",
              name: "posts",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tabName = 'posts'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_message_input)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
      (_ctx.groupEdit)
        ? (_openBlock(), _createBlock(_component_group_edit_popup, {
            key: 0,
            onOnCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.groupEdit = false)),
            onOnDone: _ctx.handleOnGroupInfoDone,
            "prev-data": _ctx.groupInfo
          }, null, 8, ["onOnDone", "prev-data"]))
        : _createCommentVNode("", true),
      (_ctx.memberEdit)
        ? (_openBlock(), _createBlock(_component_spaces_manage_members_pop_up, {
            key: 1,
            onOnCancel: _cache[8] || (_cache[8] = ($event: any) => {_ctx.memberEdit = false; _ctx.clearContactsManage}),
            "prev-data": _ctx.groupInfo,
            "users-to-add": _ctx.groupUsers,
            "users-to-invite": _ctx.usersToInvite,
            onUpdateUsers: _ctx.updateUsersToAdd,
            onOnDone: _ctx.pushContacts
          }, null, 8, ["prev-data", "users-to-add", "users-to-invite", "onUpdateUsers", "onOnDone"]))
        : _createCommentVNode("", true),
      (_ctx.settingsEdit)
        ? (_openBlock(), _createBlock(_component_group_settings_popup, {
            key: 2,
            onOnCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.settingsEdit = false)),
            "group-data": _ctx.groupInfo
          }, null, 8, ["group-data"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}